// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AgenciesRouteImport } from './routes/agencies'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as ManageReviewsRouteImport } from './routes/manage-reviews'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ReviewFormsRouteImport } from './routes/review-forms'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CompareIndexRouteImport } from './routes/compare.index'
import { Route as CompareSlugRouteImport } from './routes/compare.$slug'
import { Route as FSlugRouteImport } from './routes/f.$slug'
import { Route as ForPlatformRouteImport } from './routes/for.$platform'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations.index'
import { Route as PreviewWidgetRouteImport } from './routes/preview.widget'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsSlugRouteImport } from './routes/tools.$slug'
import { Route as WhoItsForIndexRouteImport } from './routes/who-its-for/index'
import { Route as WhoItsForSlugRouteImport } from './routes/who-its-for/$slug'
import { Route as WidgetsIndexRouteImport } from './routes/widgets.index'
import { Route as WidgetsSlugRouteImport } from './routes/widgets.$slug'
import { Route as IntegrationsSlugIndexRouteImport } from './routes/integrations.$slug.index'
import { Route as IntegrationsSlugPlatformRouteImport } from './routes/integrations.$slug.$platform'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AgenciesRoute = AgenciesRouteImport.update({
            id: '/agencies',path: '/agencies',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const DesignSystemRoute = DesignSystemRouteImport.update({
            id: '/design-system',path: '/design-system',getParentRoute: () => rootRouteImport
          })
const ManageReviewsRoute = ManageReviewsRouteImport.update({
            id: '/manage-reviews',path: '/manage-reviews',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ReviewFormsRoute = ReviewFormsRouteImport.update({
            id: '/review-forms',path: '/review-forms',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CompareIndexRoute = CompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => rootRouteImport
          })
const CompareSlugRoute = CompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => rootRouteImport
          })
const FSlugRoute = FSlugRouteImport.update({
            id: '/f/$slug',path: '/f/$slug',getParentRoute: () => rootRouteImport
          })
const ForPlatformRoute = ForPlatformRouteImport.update({
            id: '/for/$platform',path: '/for/$platform',getParentRoute: () => rootRouteImport
          })
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
            id: '/integrations/',path: '/integrations/',getParentRoute: () => rootRouteImport
          })
const PreviewWidgetRoute = PreviewWidgetRouteImport.update({
            id: '/preview/widget',path: '/preview/widget',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsSlugRoute = ToolsSlugRouteImport.update({
            id: '/tools/$slug',path: '/tools/$slug',getParentRoute: () => rootRouteImport
          })
const WhoItsForIndexRoute = WhoItsForIndexRouteImport.update({
            id: '/who-its-for/',path: '/who-its-for/',getParentRoute: () => rootRouteImport
          })
const WhoItsForSlugRoute = WhoItsForSlugRouteImport.update({
            id: '/who-its-for/$slug',path: '/who-its-for/$slug',getParentRoute: () => rootRouteImport
          })
const WidgetsIndexRoute = WidgetsIndexRouteImport.update({
            id: '/widgets/',path: '/widgets/',getParentRoute: () => rootRouteImport
          })
const WidgetsSlugRoute = WidgetsSlugRouteImport.update({
            id: '/widgets/$slug',path: '/widgets/$slug',getParentRoute: () => rootRouteImport
          })
const IntegrationsSlugIndexRoute = IntegrationsSlugIndexRouteImport.update({
            id: '/integrations/$slug/',path: '/integrations/$slug/',getParentRoute: () => rootRouteImport
          })
const IntegrationsSlugPlatformRoute = IntegrationsSlugPlatformRouteImport.update({
            id: '/integrations/$slug/$platform',path: '/integrations/$slug/$platform',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AgenciesRoute: AgenciesRoute,CookiePolicyRoute: CookiePolicyRoute,DesignSystemRoute: DesignSystemRoute,ManageReviewsRoute: ManageReviewsRoute,PartnersRoute: PartnersRoute,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ReviewFormsRoute: ReviewFormsRoute,TermsOfServiceRoute: TermsOfServiceRoute,BlogSlugRoute: BlogSlugRoute,CompareSlugRoute: CompareSlugRoute,FSlugRoute: FSlugRoute,ForPlatformRoute: ForPlatformRoute,PreviewWidgetRoute: PreviewWidgetRoute,ToolsSlugRoute: ToolsSlugRoute,WhoItsForSlugRoute: WhoItsForSlugRoute,WidgetsSlugRoute: WidgetsSlugRoute,BlogIndexRoute: BlogIndexRoute,CompareIndexRoute: CompareIndexRoute,IntegrationsIndexRoute: IntegrationsIndexRoute,ToolsIndexRoute: ToolsIndexRoute,WhoItsForIndexRoute: WhoItsForIndexRoute,WidgetsIndexRoute: WidgetsIndexRoute,IntegrationsSlugPlatformRoute: IntegrationsSlugPlatformRoute,IntegrationsSlugIndexRoute: IntegrationsSlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)